import React from 'react';
import { convertFromRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import { BLOCK_TYPE, ENTITY_TYPE } from 'draftail';
/**
 * Convert draft raw to html string
 * @param {unknown} raw - The draft raw
 * @returns {string} - The html string
 */
export default (function (raw) { return raw ? convertToHTML(exporterConfig)(convertFromRaw(raw)) : ''; });
/* Private */
var exporterConfig = {
    blockToHTML: function (block) {
        if (block.type === BLOCK_TYPE.BLOCKQUOTE) {
            return React.createElement("blockquote", null);
        }
        if (block.type === 'code-block') {
            return React.createElement("code", null, block.text);
        }
        // Discard atomic blocks, as they get converted based on their entity.
        if (block.type === BLOCK_TYPE.ATOMIC) {
            return {
                start: '',
                end: '',
            };
        }
        return null;
    },
    entityToHTML: function (entity, originalText) {
        if (entity.type === ENTITY_TYPE.LINK) {
            return React.createElement("a", { href: entity.data.url }, originalText);
        }
        if (entity.type === ENTITY_TYPE.HORIZONTAL_RULE) {
            return React.createElement("hr", null);
        }
        return originalText;
    },
};
